import { api, requestTokenRefresh } from '~/utils/api'
import type { LoginParam } from '~/apis/auth/type'

// 로그인
export const userLoginApi = (params: LoginParam) => {
  return api.post('/bus/api/login/loginUserInfo', params)
}

// accessToken 로그인
export const loginTokenInfoApi = () => {
  return api.get('/bus/api/login/loginTokenInfo')
}

// refresh token 검증 & 갱신 처리
export const refreshTokenApi = () => {
  return requestTokenRefresh()
}
